import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import { RctCard, RctCardContent } from 'Components/RctCard';

import { 
    
 } from 'Actions';

class GolfIntervention extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    UNSAFE_componentWillMount() {
        
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            student:'', 
            loader:false,
            
        };
    }


render() {

    const { playerinterventionlist, loading} = this.props;   
    

      return(
        <div>
                <div className="row">
                     
                     <div className="col-sm-12 col-lg-3">
                        <RctCard>
                           <a onClick={() =>this.props.onClick(1)} >
                              <RctCardContent>
                                 <img src={require('Assets/img/dashboard/invt_longgame.jpg')} className="img-fluid" alt="site-logo" />
                                 <button class="btn btn-info btn-block">LONG GAME</button>
                                 <div className="text-center">Total : <strong>{playerinterventionlist.range.longgame}</strong></div>
                              </RctCardContent>
                           </a>   
                        </RctCard>      
                     </div> 
                     <div className="col-sm-12 col-lg-3">
                        <RctCard>
                           <a onClick={() =>this.props.onClick(2)} >
                              <RctCardContent>
                                 <img src={require('Assets/img/dashboard/invt_shortgame.jpg')} className="img-fluid" alt="site-logo" />
                                 <button class="btn btn-info btn-block">SHORT GAME</button>
                                 <div className="text-center">Total : <strong>{playerinterventionlist.range.shortgame}</strong></div>
                              </RctCardContent>
                           </a>   
                        </RctCard>      
                     </div> 
                     <div className="col-sm-12 col-lg-3">
                        <RctCard>
                           <a onClick={() =>this.props.onClick(3)} >
                              <RctCardContent>
                                 <img src={require('Assets/img/dashboard/invt_putting.jpg')} className="img-fluid" alt="site-logo" />
                                 <button class="btn btn-info btn-block">PUTTING</button>
                                 <div className="text-center">Total : <strong>{playerinterventionlist.range.putting}</strong></div>
                              </RctCardContent>
                           </a>   
                        </RctCard>      
                     </div> 
                     <div className="col-sm-12 col-lg-3">
                        <RctCard>
                           <a onClick={() =>this.props.onClick(4)} >
                              <RctCardContent>
                                 <img src={require('Assets/img/dashboard/invt_course.jpg')} className="img-fluid" alt="site-logo" />
                                 <button class="btn btn-info btn-block">COURSE INTERVENTION</button>
                                 <div className="text-center">Total : <strong>{playerinterventionlist.course.total}</strong></div>
                              </RctCardContent>
                           </a>   
                        </RctCard>      
                     </div> 
                     
                    
                </div>       
        </div>
              
    )
   
}
 
}

const mapStateToProps = ({ playerintervention}) => {
    const { playerinterventionlist, loading } = playerintervention;
    return { playerinterventionlist, loading };
   
}


export default connect(mapStateToProps, {
    
})(GolfIntervention);
